import { Mark, mergeAttributes } from '@tiptap/core';

export interface OmissisOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    omissis: {
      /**
       * Set an omissis mark
       */
      setOmissis: () => ReturnType;
      /**
       * Toggle an omissis mark
       */
      toggleOmissis: () => ReturnType;
      /**
       * Unset an omissis mark
       */
      unsetOmissis: () => ReturnType;
    };
  }
}

/**
 * Mark custom per marcare il testo come omissis.
 */
export const OmissisMarkExtension = Mark.create<OmissisOptions>({
  name: 'omissis',

  // Priorità alta: fa sì che `omissis` sia sempre il mark più esterno nello
  // schema (rank più basso). In questo modo, quando si annidano altri mark
  // (es. `strong`), lo span `data-omissis` resta unico e continuo e avvolge
  // gli altri tag invece di essere spezzato in più span.
  priority: 1001,

  addOptions() {
    return {
      HTMLAttributes: { 'data-omissis': 'true' },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-omissis="true"]',
        getAttrs: (element: string | HTMLElement) => {
          return (
            typeof element !== 'string' &&
            element.getAttribute('data-omissis') ===
              this.options.HTMLAttributes['data-omissis'] &&
            null
          );
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },

  addCommands() {
    return {
      setOmissis:
        () =>
        ({ commands }) => {
          return commands.setMark(this.name);
        },
      toggleOmissis:
        () =>
        ({ commands }) => {
          return commands.toggleMark(this.name);
        },
      unsetOmissis:
        () =>
        ({ commands }) => {
          return commands.unsetMark(this.name);
        },
    };
  },
});
